interface ISigninProps {
    email: string;
    isModal?: boolean;
    goBack: () => void;
}

const CheckYourEmail: React.FC<ISigninProps> = ({email, isModal, goBack}) => {
    return (
        <div className={!isModal ? 'card overflow-hidden' : ''}>
            <div className="px-3 pt-3">
                <h2 style={{fontSize: '28px'}} className="title mb-4">Hi there!</h2>
                <p>It looks like you’re new to Purr. We’ve sent an email to {email} to help get you started.</p>
                <p><b>Please check your email now to create your account.</b></p>
            </div>
            <div
                className="d-flex flex-column flex-sm-row align-items-center justify-content-center w-100 p-3"
                style={{
                    background: '#FAFAFA',
                    borderTop: '1px solid #E4E4E7'
                }}>
                <div>
                  <span>Already have an account? </span>
                  <a className="text-link cursor-pointer" onClick={() => goBack?.()}>Use a different email</a>
                </div>
            </div>
        </div>
    );
};

export default CheckYourEmail;
